/**
 * Course onboarding guide.
 */
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";

import { VButton } from "form";
import Guide1 from "./guide1";
import Guide2 from "./guide2";
import Guide3 from "./guide3";
import Guide4 from "./guide4";
import Guide5 from "./guide5";
import Guide6 from "./guide6";

/**
 * Multi-step welcome guide for a course.
 */
const Guide = () => {
  const { t } = useTranslation("common");

  const navigate = useNavigate();
  const { courseId } = useParams();

  const [num, setNum] = useState(1);
  const [contentHeight, setContentHeight] = useState(500);

  useEffect(() => {
    const totalHeight = window.innerHeight;
    setContentHeight(totalHeight - 77 - 48);
  }, []);

  /**
   * Advances or leaves the guide.
   *
   * @param {number|string} page Next step or destination.
   * @returns {void}
   */
  const onNavigate = (page) => {
    if (page > 0 && page < 7) setNum(page);
    if (page > 6) {
      navigate(`/course/${courseId}`);
    }
  };

  return (
    <Box className="p-0 md:p-6 flex-1">
      <Box className="h-full mx-auto v-bg-body rounded-none md:rounded-md p-4" sx={{ minHeight: contentHeight }}>
        <Box className="w-full rounded-md border-0 md:border border-solid border-gray-300 dark:border-gray-500 flex-1">
          <Box className="p-0 md:p-4">
            {num === 1 && <Guide1 />}
            {num === 2 && <Guide2 />}
            {num === 3 && <Guide3 />}
            {num === 4 && <Guide4 />}
            {num === 5 && <Guide5 />}
            {num === 6 && <Guide6 />}
          </Box>

          <Divider className="bg-gray-200 dark:bg-gray-500 hidden md:flex" />

          <Box className="flex justify-between pt-4 md:py-10 md:px-4 px-0">
            <VButton variant="outlined" color="secondary" className="px-8" startIcon={<Icon icon="akar-icons:arrow-left" />} onClick={() => onNavigate(num - 1)} disabled={num === 1}>
              {t("Previous")}
            </VButton>
            <VButton variant="contained" color="primary" className="px-8" endIcon={<Icon icon="akar-icons:arrow-right" />} onClick={() => onNavigate(num + 1)}>
              {num < 6 ? t("Next") : t("Start Course")}
            </VButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Guide;
